import { Box, Tab, Tabs } from "@mui/material";
import { useMemo, useEffect, useState } from "react";
import { TabConfig } from "../../../interface";
import classes from "./CustomTabs.module.scss";

interface CustomTabsProps {
  name: string;
  tabConfig: TabConfig[];
  onTabChange?: React.Dispatch<React.SetStateAction<number>>;
  activeTab?: number;
}

const CustomTabs: React.FC<CustomTabsProps> = ({
  activeTab,
  name,
  tabConfig,
  onTabChange,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (activeTab !== undefined) setSelectedTab(activeTab);
  }, [activeTab]);

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setSelectedTab(newValue);
    if (onTabChange) onTabChange(newValue);
  };

  const a11yProps = (index: number) => {
    return {
      id: `custom-tab-${index}`,
      "aria-controls": `custom-tabpanel-${index}`,
    };
  };

  const activeTabContent = useMemo(() => {
    return tabConfig[selectedTab]?.tabContent;
  }, [selectedTab, tabConfig]);

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        data-testid={`${name}-tabs-container"`}
        aria-label="custom tabs"
        className={classes["custom-tab-container"]}
      >
        {tabConfig?.map((item: TabConfig, index: number) => {
          return (
            <Tab
              className={classes["tabHeader"]}
              key={item.id}
              label={item.tabName}
              {...a11yProps(index)}
              data-testid={`${name}-tabs-header-${index}`}
            />
          );
        })}
      </Tabs>
      <Box
        role="tabpanel"
        id={`custom-tabpanel-${selectedTab}`}
        data-testid={`custom-tabpanel-${selectedTab}`}
        aria-labelledby={`custom-tab-${selectedTab}`}
      >
        {activeTabContent}
      </Box>
    </>
  );
};

export default CustomTabs;
